import StaffListGrid from './StaffListGrid';
const Components = {
    StaffListGrid
}

export default Components;